import React from 'react';
import HeroSection from './HeroSection';
import AllSections from './AllSections';
import { CookieModal } from '../CookieModal/CookieModal';
import CalltoAction from '../Common/CalltoAction';

const Home = () => {

    return (
        <>
            <HeroSection />
            <AllSections />
            <CalltoAction />
            <CookieModal />
        </>
    );

}
export default Home